import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 1400,
    margin: '0 auto',
    paddingTop: '50px',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100vh - 56px)',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.default,
    marginTop: theme.spacing(-4),
    marginLeft: theme.spacing(-3),
    marginRight: theme.spacing(-3),
  },
  breadcrumb: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(1.5, 3),
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    flexShrink: 0,
  },
  backButton: {
    padding: theme.spacing(0.5),
    color: theme.palette.text.primary,
  },
  courseTitle: {
    fontSize: 18,
    fontWeight: 700,
    color: theme.palette.text.primary,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  body: {
    display: 'flex',
    flex: 1,
    overflow: 'hidden',
  },
  mainContent: {
    flex: 1,
    overflowY: 'auto',
    padding: theme.spacing(2),
  },
  navigation: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(3),
  },
  prevButton: {
    textTransform: 'none',
    fontWeight: 700,
    color: theme.palette.text.secondary,
    padding: theme.spacing(0.5, 3),
  },
  nextButton: {
    textTransform: 'none',
    fontWeight: 700,
    backgroundColor: theme.palette.common.black,
    color: theme.palette.white,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    '&:disabled': {
      backgroundColor: theme.palette.divider,
      color: theme.palette.text.secondary,
    },
    '&:hover': {
      backgroundColor: theme.palette.common.black,
      opacity: 0.8,
    },
  },
  lessonTitle: {
    fontSize: 22,
    fontWeight: 700,
    color: theme.palette.text.primary,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
  },
  lessonBody: {
    fontSize: 14,
    color: theme.palette.text.primary,
    fontFamily: theme.typography.fontFamily,
    lineHeight: 1.8,
    '& p': { marginBottom: theme.spacing(1.5) },
    '& h1, & h2, & h3, & h4': {
      fontWeight: 700,
      marginTop: theme.spacing(2.5),
      marginBottom: theme.spacing(1),
    },
    '& ul, & ol': {
      paddingLeft: theme.spacing(3),
      marginBottom: theme.spacing(1.5),
    },
    '& strong': { fontWeight: 700 },
    '& a': { color: theme.palette.text.link },
    '& table': {
      borderCollapse: 'collapse',
      width: '100%',
      marginBottom: theme.spacing(1.5),
    },
    '& th, & td': {
      border: `1px solid ${theme.palette.divider}`,
      padding: theme.spacing(1, 1.5),
      textAlign: 'left',
    },
    '& th': {
      fontWeight: 700,
      backgroundColor: theme.palette.background.default,
    },
  },
}))

export default useStyles
